// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__mKrmU.styles_ocean-50__y5TbY {
  color: #e6f2ff;
}

.styles_color__mKrmU.styles_ocean-100__oEX5Q {
  color: #e6f2ff;
}

.styles_color__mKrmU.styles_ocean-200__9M2pf {
  color: #b3daff;
}

.styles_color__mKrmU.styles_ocean-300__gFXLM {
  color: #7abfff;
}

.styles_color__mKrmU.styles_ocean-400__HUAoG {
  color: #2392fb;
}

.styles_color__mKrmU.styles_ocean-500__DnGPj {
  color: #0074e0;
}

.styles_color__mKrmU.styles_ocean-600__ATOjh {
  color: #043571;
}

.styles_color__mKrmU.styles_space-50__ohQOo {
  color: #f0f0f0;
}

.styles_color__mKrmU.styles_space-100__MlN97 {
  color: #e3e3e3;
}

.styles_color__mKrmU.styles_space-200__4IngD {
  color: #bfbfbf;
}

.styles_color__mKrmU.styles_space-300__zyjI3 {
  color: gray;
}

.styles_color__mKrmU.styles_space-400__qADyi {
  color: #616161;
}

.styles_color__mKrmU.styles_space-500__9o7L5 {
  color: #283439;
}

.styles_color__mKrmU.styles_gray-50__Z854A {
  color: #eff3f6;
}

.styles_color__mKrmU.styles_gray-100__Y5CC\\+ {
  color: #e6ecef;
}

.styles_color__mKrmU.styles_gray-200__Rh0tj {
  color: #cfd8de;
}

.styles_color__mKrmU.styles_gray-300__cg55P {
  color: #a8b9c2;
}

.styles_color__mKrmU.styles_gray-400__2DSbF {
  color: #7e98a5;
}

.styles_color__mKrmU.styles_gray-500__Bw9kg {
  color: #738f9c;
}

.styles_color__mKrmU.styles_green-50__CIH6E {
  color: #e3fdf6;
}

.styles_color__mKrmU.styles_green-100__ovsIG {
  color: #c5f6ea;
}

.styles_color__mKrmU.styles_green-200__v69kT {
  color: #69ddc2;
}

.styles_color__mKrmU.styles_green-300__mda0T {
  color: #45bfa3;
}

.styles_color__mKrmU.styles_green-400__G\\+HbA {
  color: #1cab8a;
}

.styles_color__mKrmU.styles_green-500__Jz349 {
  color: #128268;
}

.styles_color__mKrmU.styles_red-50__awghL {
  color: #fff0f3;
}

.styles_color__mKrmU.styles_red-100__upG2G {
  color: #f9d2db;
}

.styles_color__mKrmU.styles_red-200__t8GJ5 {
  color: #f8b4c4;
}

.styles_color__mKrmU.styles_red-300__CuqkU {
  color: #e85e81;
}

.styles_color__mKrmU.styles_red-400__mRPOg {
  color: #e23661;
}

.styles_color__mKrmU.styles_red-500__X8Gss {
  color: #b82348;
}

.styles_color__mKrmU.styles_yellow-50__BYNxh {
  color: #fffae6;
}

.styles_color__mKrmU.styles_yellow-100__BmO4h {
  color: #fff0b3;
}

.styles_color__mKrmU.styles_yellow-200__M50xU {
  color: #ffe380;
}

.styles_color__mKrmU.styles_yellow-300__t10Kq {
  color: #ffcf57;
}

.styles_color__mKrmU.styles_yellow-400__KXnnA {
  color: #ffc60a;
}

.styles_color__mKrmU.styles_yellow-500__vOVmR {
  color: #ffb700;
}

.styles_color__mKrmU.styles_orange-50__YOvTb {
  color: #fff2eb;
}

.styles_color__mKrmU.styles_orange-100__3qLaL {
  color: #ffe4d6;
}

.styles_color__mKrmU.styles_orange-200__FG2QP {
  color: #ffc69e;
}

.styles_color__mKrmU.styles_orange-300__TjH2U {
  color: #ffa047;
}

.styles_color__mKrmU.styles_orange-400__I5Qte {
  color: #ff7b42;
}

.styles_color__mKrmU.styles_orange-500__CaNus {
  color: #ee4920;
}

.styles_color__mKrmU.styles_turquoise-50__tTTMD {
  color: transparent;
}

.styles_color__mKrmU.styles_turquoise-100__uS-fa {
  color: #e6fcff;
}

.styles_color__mKrmU.styles_turquoise-200__qECrF {
  color: #b3f5ff;
}

.styles_color__mKrmU.styles_turquoise-300__JbHsC {
  color: #78e2f2;
}

.styles_color__mKrmU.styles_turquoise-400__-rIM0 {
  color: #00c7e6;
}

.styles_color__mKrmU.styles_turquoise-500__NCc-b {
  color: transparent;
}

.styles_color__mKrmU.styles_turquoise-600__8zxGX {
  color: transparent;
}

.styles_color__mKrmU.styles_violet-50__YjgBl {
  color: #eae6ff;
}

.styles_color__mKrmU.styles_violet-100__B5Mfj {
  color: #d9d1ff;
}

.styles_color__mKrmU.styles_violet-200__38tX- {
  color: #bfb3ff;
}

.styles_color__mKrmU.styles_violet-300__Af-cR {
  color: #9d90ea;
}

.styles_color__mKrmU.styles_violet-400__tOx4a {
  color: #8678d9;
}

.styles_color__mKrmU.styles_violet-500__tOxkt {
  color: #6f5ccc;
}

.styles_color__mKrmU.styles_snow-50__TCazi {
  color: white;
}

.styles_color__mKrmU.styles_snow-100__ddfYr {
  color: #f7f7f7;
}

.styles_color__mKrmU.styles_snow-200__GZtsN {
  color: #f0efef;
}

.styles_color__mKrmU.styles_snow-300__UL1lW {
  color: #e6e6e6;
}

.styles_color__mKrmU.styles_snow-400__bJ0tG {
  color: #e1e0e0;
}

.styles_color__mKrmU.styles_snow-500__aHPn0 {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__ifPze.styles_ocean__gEYkq {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__ifPze.styles_ocean-light__HbpAp {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__ifPze.styles_green__Cv\\+qI {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__ifPze.styles_green-light__UzbP3 {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__ifPze.styles_red__h0xbV {
  background-color: #e23661;
  color: white;
}

.styles_background-color__ifPze.styles_red-light__Za46n {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__ifPze.styles_orange__UBSnv {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__ifPze.styles_orange-light__uo9Km {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__ifPze.styles_space__yQ\\+iu {
  background-color: #616161;
  color: white;
}

.styles_background-color__ifPze.styles_space-light__Kkn5q {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__ifPze.styles_gray-light__WvEhd {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__ifPze.styles_violet__IGf8u {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__ifPze.styles_violet-light__Q10ng {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__ifPze.styles_yellow__apXwV {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__ifPze.styles_yellow-light__IF45u {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__Rh70R {
  background-color: white;
  max-height: 106px;
  min-height: 66px;
  padding: 8px 16px ;
}
@media (min-width: 960px) {
  .styles_root__Rh70R {
    background-color: transparent;
  }
}
.styles_root__Rh70R .styles_inputText__fsG3z {
  background-color: white;
  padding: 16px 12px ;
}
.styles_root__Rh70R .styles_actionButton__ZSgWn {
  margin-left: 8px ;
}

.styles_archivedRoomInfo__W9c7Z {
  background-color: #f7f7f7;
  padding: 24px ;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/chat/content/footer/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_media-query.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA0UJ;AE1TY;EFpBZ;IAOQ,6BAAA;EA2UN;AACF;AAzUI;EACI,uBAAA;EACA,mBAAA;AA2UR;AAxUI;EACI,iBAAA;AA0UR;;AAtUA;EACI,yBAAA;EACA,cAAA;EACA,kBAAA;AAyUJ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    background-color: theme.color(snow-50);\n    max-height: 106px;\n    min-height: 66px;\n    padding: theme.spacing(1, 2);\n\n    @include theme.mq-up(md) {\n        background-color: transparent;\n    }\n\n    .inputText {\n        background-color: theme.color(snow-50);\n        padding: theme.spacing(2, 1.5);\n    }\n\n    .actionButton {\n        margin-left: theme.spacing(1);\n    }\n}\n\n.archivedRoomInfo {\n    background-color: theme.color(snow-100);\n    padding: theme.spacing(3);\n    text-align: center;\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:list';\n@use 'sass:map';\n\n$breakpoints: (\n    xs: 0,\n    sm: 600px,\n    md: 960px,\n    lg: 1280px,\n    xl: 1920px,\n);\n$breakpoint-keys: map.keys($breakpoints);\n$breakpoint-unit: px;\n$breakpoint-step: 0.05;\n\n@function breakpoint($breakpointName: xs) {\n    @return map.get($breakpoints, $breakpointName);\n}\n\n@mixin mq-up($breakpoint, $show-warning: true) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $index: list.index($breakpoint-keys, $breakpoint);\n\n        @if $index > 1 {\n            @media (min-width: map.get($breakpoints, $breakpoint)) {\n                @content;\n            }\n        } @else {\n            @content;\n\n            // stylelint-disable-next-line max-nesting-depth\n            @if $show-warning {\n                @warn 'Using #{$breakpoint} breakpoint as mq-up is redundant. Remove the media query.';\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq-down($breakpoint) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $upper-index: list.index($breakpoint-keys, $breakpoint) + 1;\n\n        @if $upper-index == list.length($breakpoint-keys) + 1 {\n            $lowest-breakpoint-key: list.nth($breakpoint-keys, 1);\n\n            /* stylelint-disable-next-line max-line-length */\n            @warn 'Using #{$breakpoint} breakpoint as mq-down is redundant. Use mq-up(#{$lowest-breakpoint-key}) instead.';\n\n            @include mq-up($lowest-breakpoint-key, false) {\n                @content;\n            }\n        } @else {\n            $upper-breakpoint-key: list.nth($breakpoint-keys, $upper-index);\n\n            @media (max-width: map.get($breakpoints, $upper-breakpoint-key) - $breakpoint-step) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq-between($start-breakpoint, $end-breakpoint, $show-warning: true) {\n    @if map.has-key($breakpoints, $start-breakpoint) and map.has-key($breakpoints, $end-breakpoint) {\n        $start-index: list.index($breakpoint-keys, $start-breakpoint);\n        $end-index: list.index($breakpoint-keys, $end-breakpoint);\n\n        @if $end-index == list.length($breakpoint-keys) {\n            @if $show-warning {\n                /* stylelint-disable-next-line max-line-length */\n                @warn 'Using #{$end-breakpoint} breakpoint as mq-betwen end is redundant. Use mq-up(#{$start-breakpoint}) instead.';\n            }\n\n            @include mq-up($start-breakpoint) {\n                @content;\n            }\n        } @else {\n            @if $start-index == $end-index {\n                @if $show-warning {\n                    @warn 'Start and end breakpoints are the same. Use mq-only(#{$start-breakpoint}) instead.';\n                }\n            } @else if $start-index > $end-index {\n                @if $show-warning {\n                    /* stylelint-disable-next-line max-line-length */\n                    @warn 'Start breakpoint (#{$start-breakpoint}) is bigger than end breakpoint (#{$end-breakpoint}). Remove it or change it.';\n                }\n            }\n\n            $upper-breakpoint: list.nth($breakpoint-keys, $end-index + 1);\n\n            @media\n                (min-width: map.get($breakpoints, $start-breakpoint)) and\n                (max-width: map.get($breakpoints, $upper-breakpoint) - $breakpoint-step) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Both or one of the given breakpoints (#{$start-breakpoint}, #{$end-breakpoint}) is missing.';\n    }\n}\n\n@mixin mq-only($breakpoint) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $index: list.index($breakpoint-keys, $breakpoint);\n\n        @if $index == list.length($breakpoint-keys) {\n            /* stylelint-disable-next-line max-line-length */\n            @warn 'Using #{$breakpoint} breakpoint as mq-only parameter is redundant. Use mq-up(#{$breakpoint}) instead.';\n\n            @include mq-up($breakpoint) {\n                @content;\n            }\n        } @else {\n            @include mq-between($breakpoint, $breakpoint, false) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq($condition, $breakpoint-one, $breakpoint-two: null) {\n    @if ($condition == up) {\n        @include mq-up($breakpoint-one) {\n            @content;\n        }\n    } @else if ($condition == down) {\n        @include mq-down($breakpoint-one) {\n            @content;\n        }\n    } @else if ($condition == between) {\n        @include mq-between($breakpoint-one, $breakpoint-two) {\n            @content;\n        }\n    } @else if ($condition == only) {\n        @include mq-only($breakpoint-one) {\n            @content;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__mKrmU`,
	"ocean-50": `styles_ocean-50__y5TbY`,
	"ocean-100": `styles_ocean-100__oEX5Q`,
	"ocean-200": `styles_ocean-200__9M2pf`,
	"ocean-300": `styles_ocean-300__gFXLM`,
	"ocean-400": `styles_ocean-400__HUAoG`,
	"ocean-500": `styles_ocean-500__DnGPj`,
	"ocean-600": `styles_ocean-600__ATOjh`,
	"space-50": `styles_space-50__ohQOo`,
	"space-100": `styles_space-100__MlN97`,
	"space-200": `styles_space-200__4IngD`,
	"space-300": `styles_space-300__zyjI3`,
	"space-400": `styles_space-400__qADyi`,
	"space-500": `styles_space-500__9o7L5`,
	"gray-50": `styles_gray-50__Z854A`,
	"gray-100": `styles_gray-100__Y5CC+`,
	"gray-200": `styles_gray-200__Rh0tj`,
	"gray-300": `styles_gray-300__cg55P`,
	"gray-400": `styles_gray-400__2DSbF`,
	"gray-500": `styles_gray-500__Bw9kg`,
	"green-50": `styles_green-50__CIH6E`,
	"green-100": `styles_green-100__ovsIG`,
	"green-200": `styles_green-200__v69kT`,
	"green-300": `styles_green-300__mda0T`,
	"green-400": `styles_green-400__G+HbA`,
	"green-500": `styles_green-500__Jz349`,
	"red-50": `styles_red-50__awghL`,
	"red-100": `styles_red-100__upG2G`,
	"red-200": `styles_red-200__t8GJ5`,
	"red-300": `styles_red-300__CuqkU`,
	"red-400": `styles_red-400__mRPOg`,
	"red-500": `styles_red-500__X8Gss`,
	"yellow-50": `styles_yellow-50__BYNxh`,
	"yellow-100": `styles_yellow-100__BmO4h`,
	"yellow-200": `styles_yellow-200__M50xU`,
	"yellow-300": `styles_yellow-300__t10Kq`,
	"yellow-400": `styles_yellow-400__KXnnA`,
	"yellow-500": `styles_yellow-500__vOVmR`,
	"orange-50": `styles_orange-50__YOvTb`,
	"orange-100": `styles_orange-100__3qLaL`,
	"orange-200": `styles_orange-200__FG2QP`,
	"orange-300": `styles_orange-300__TjH2U`,
	"orange-400": `styles_orange-400__I5Qte`,
	"orange-500": `styles_orange-500__CaNus`,
	"turquoise-50": `styles_turquoise-50__tTTMD`,
	"turquoise-100": `styles_turquoise-100__uS-fa`,
	"turquoise-200": `styles_turquoise-200__qECrF`,
	"turquoise-300": `styles_turquoise-300__JbHsC`,
	"turquoise-400": `styles_turquoise-400__-rIM0`,
	"turquoise-500": `styles_turquoise-500__NCc-b`,
	"turquoise-600": `styles_turquoise-600__8zxGX`,
	"violet-50": `styles_violet-50__YjgBl`,
	"violet-100": `styles_violet-100__B5Mfj`,
	"violet-200": `styles_violet-200__38tX-`,
	"violet-300": `styles_violet-300__Af-cR`,
	"violet-400": `styles_violet-400__tOx4a`,
	"violet-500": `styles_violet-500__tOxkt`,
	"snow-50": `styles_snow-50__TCazi`,
	"snow-100": `styles_snow-100__ddfYr`,
	"snow-200": `styles_snow-200__GZtsN`,
	"snow-300": `styles_snow-300__UL1lW`,
	"snow-400": `styles_snow-400__bJ0tG`,
	"snow-500": `styles_snow-500__aHPn0`,
	"background-color": `styles_background-color__ifPze`,
	"ocean": `styles_ocean__gEYkq`,
	"ocean-light": `styles_ocean-light__HbpAp`,
	"green": `styles_green__Cv+qI`,
	"green-light": `styles_green-light__UzbP3`,
	"red": `styles_red__h0xbV`,
	"red-light": `styles_red-light__Za46n`,
	"orange": `styles_orange__UBSnv`,
	"orange-light": `styles_orange-light__uo9Km`,
	"space": `styles_space__yQ+iu`,
	"space-light": `styles_space-light__Kkn5q`,
	"gray-light": `styles_gray-light__WvEhd`,
	"violet": `styles_violet__IGf8u`,
	"violet-light": `styles_violet-light__Q10ng`,
	"yellow": `styles_yellow__apXwV`,
	"yellow-light": `styles_yellow-light__IF45u`,
	"root": `styles_root__Rh70R`,
	"inputText": `styles_inputText__fsG3z`,
	"actionButton": `styles_actionButton__ZSgWn`,
	"archivedRoomInfo": `styles_archivedRoomInfo__W9c7Z`
};
export default ___CSS_LOADER_EXPORT___;
